import { ADD_FORM_TAB_MAINPAGE } from '../../constants/experiments';
import { ESpecialTabs } from '../../constants/specialTabs';
import { IApplicationState } from '../../types/redux';
import { FDealType } from '../category';
import { getExperimentGroup } from '../getExperimentGroup';

export function isAddformTabEnabled(state: IApplicationState, currentTab: FDealType | ESpecialTabs) {
  const isSaleOrRentTab = currentTab === FDealType.Sale || currentTab === FDealType.RentLongterm;

  if (!isSaleOrRentTab) {
    return false;
  }

  const inExperiment = getExperimentGroup(state.abUseExperiments, ADD_FORM_TAB_MAINPAGE) === 'B';

  if (!inExperiment) {
    return false;
  }

  return true;
}
